import { AxiosInstance } from 'axios'
import { IQuestionImportResponse, IQuestionImportStatusResponse } from '../../../types/question.types'

export function questionsImportApiFactory(api: AxiosInstance) {
  const baseUrl = '/api/v1/import/questions'

  const methods = {
    import(importId: number) {
      return api.put<IQuestionImportResponse>(`${baseUrl}/${importId}`)
    },
    upload(file: File) {
      const formData = new FormData()
      formData.append('file', file)

      return api.post<IQuestionImportResponse>(`${baseUrl}/upload`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
    },
    getImportStatus(importId: number) {
      return api.get<IQuestionImportStatusResponse[]>(`${baseUrl}/${importId}/status`)
    },
    getImportsInProgress() {
      return api.get<IQuestionImportStatusResponse[]>(`${baseUrl}/status`)
    }
  }
  return methods
}
